import { matchLenderByName } from './utils/matchLenderByName';

// The notes Peak keeps per lender, offered in the Notes row of a quote whose Lender is that bank.
// ALIASES are the shorthands the team types into the Lender row instead of the full name.
const lenderNotes = [
    {
        NAME: 'Randolph Brooks Federal Credit Union',
        ALIASES: ['RBFCU'],
        NOTES: [
            'Interest rate is floating until loan approval is issued.',
            'Loan term may be shortened to match lease term or reserve account could be required due to lease rollover. Interest rate is floating until final loan approval is issued and subject to change.',
            '3 full years of CPA audited financial statements (balance sheet and income statement) on the tenant required for non-recourse, subject to lender approval. Interest rate is floating until final loan approval is issued and subject to change.',
        ],
    },
    {
        NAME: 'Woori America Bank',
        ALIASES: [],
        NOTES: [
            'Interest rate can be locked at time of LOI or float until closing. Refinance prepayment penalty only, no penalty if property is sold to an uninterested third party. Add .250 to origination fee for a 1% flat prepayment penalty or add .500 to origination fee for no prepayment penalty.',
            'Interest rate can be locked at time of LOI or float until closing. Refinance prepayment penalty only, no penalty if property is sold to an uninterested third party. Add .250 to origination fee for a 1% flat prepayment penalty or add .500 to origination fee for no prepayment penalty. Loan term may be shortened to match lease term or reserve account could be required due to lease rollover.',
            'Rate can be locked at time of LOI or float until closing. Loan term may be shortened to match lease term or reserve account could be required due to WALT.',
        ],
    },
    {
        NAME: 'US Bank',
        ALIASES: [],
        NOTES: [
            'Loan term can be renewed for longer term at annual loan renewal, pending WALT. Interest rate is floating until loan approval. Add .20 to interest rate for no prepayment penalty.',
            'Interest rate is floating until loan approval. Add .45 to interest rate for no prepayment penalty.',
            'Interest rate is floating until loan approval. Add .80 to interest rate for no prepayment penalty.',
            'Loan term may be shortened to match lease term or reserve account could be required due to lease rollover. Interest rate is floating until loan approval.',
        ],
    },
    {
        NAME: 'SouthState Bank',
        ALIASES: [],
        NOTES: [
            'Interest rate is floating until loan approval. Prepayment penalty is for refinance only, no penalty if sold to an uninterested third party.',
            'Interest rate swap Loan, interest rate is floating until closing. This loan does not have a balloon feature and will adjust annually after the fixed rate term of 5 years at 1 month SOFR + 0.230%.',
        ],
    },
    {
        NAME: 'Cathay Bank',
        ALIASES: [],
        NOTES: [
            'Optional 12-month interest only period to start followed by a 25 year fully amortizing loan. Rate is floating until closing.',
            'This is the remainder of the 5 year loan after the interest only period in the column to the left.',
        ],
    },
    {
        NAME: 'Credit Union 1',
        ALIASES: ['CU1'],
        NOTES: [
            'Interest rate held for 60 days at time of executed LOI and deposit from borrower.',
            'Reduce rate .05 for <=.60% LTV and .10 for =<50% LTV.',
            'Minimum loan amount is $1mm. Reduce interest rate .13 for additional .500 in fee. Interest rate locked for 60 days at time of executed LOI.',
        ],
    },
    {
        NAME: 'RIZE Credit Union',
        ALIASES: [],
        NOTES: [
            'Interest rate can be locked at time of executed term sheet or float until closing. Rate quote includes discount of .250% for auto payment.',
        ],
    },
    {
        NAME: 'OceanAir Federal Credit Union',
        ALIASES: [],
        NOTES: [
            '1 year of optional interest only payments followed by a 29 year fully amortizing loan. Rate is locked at time of executed LOI and good faith deposit for third party reports. Waiting for lender to confirm they can lend on this asset class.',
        ],
    },
    {
        NAME: 'Union Bank & Trust',
        ALIASES: ['UBT'],
        NOTES: [
            'Interest rate held for 60 days at time of LOI. Refinance prepayment penalty only, no penalty if property is sold to an uninterested third party.',
        ],
    },
];

export const OTHER_NOTE = 'Other — type the note';

const namesToMatch = lenderNotes.reduce(
    (names, lender) => names.concat([lender.NAME, ...lender.ALIASES].map((NAME) => ({ NAME, lender }))),
    [],
);

/** The lender a quote's Lender row names, when Peak keeps notes for it; otherwise null. */
export function lenderWithNotes(bank) {
    const match = matchLenderByName(namesToMatch, bank, { contains: false });

    return match ? match.lender : null;
}
